<ng-container
  *ngIf="{
    components: components$ | async,
    data: data$,
  } as content"
>
  <div class="simple-card">
    <h2 class="m-t-12">{{ content.data?.title }}</h2>
    <div class="abstract-grid__container m-t-12">
      <div *ngFor="let item of content.components" class="abstract-grid__item">
        <cms-abstract-grid-card [CMSAbstractGridEntry]="item" [backgroundColor]="content.data?.backgroundColor"></cms-abstract-grid-card>
      </div>
    </div>
  </div>
</ng-container>
